<form class="change-bank-transaction-status-form astral-stack-m" (ngSubmit)="onSubmit()">
  <h4>{{ title | translate }}</h4>
  <app-information-block [text]="infoText | translate"></app-information-block>

  <div class="astral-form-actions">
    <astral-button variant="primary" type="submit" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
